<template>
  <div class="whiteborder">
    <FirstTitle :titleName="titleName"></FirstTitle>
    <div class="report_form container_width">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="举报机构">
          <el-input v-model="ruleForm.agencyName" autocomplete="off" placeholder="请输入举报机构名称"></el-input>
        </el-form-item>
        <el-form-item label="事项及理由">
          <el-input
            type="textarea"
            v-model="ruleForm.reportReason"
            autocomplete="off"
            placeholder="请输入事项及理由"
          ></el-input>
        </el-form-item>
        <el-form-item label="举报联系人">
          <el-input v-model="ruleForm.reportName" autocomplete="off" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input
            v-model="ruleForm.reportIdNumber"
            autocomplete="off"
            maxlength="18"
            placeholder="请输入您的身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model="ruleForm.reportPhone"
            maxlength="11"
            autocomplete="off"
            placeholder="请输入您的联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item class="reportdata" label="举报材料" prop="reportdata">
          <a href="javascript:void(0);" class="input">
            上传附件
            <input type="file" class="file" @change="getFile($event)" />
          </a>
          <span class="currFile">{{currentFile }}</span>
        </el-form-item>
        <el-form-item class="form_button">
          <el-button @click="resetForm('ruleForm')" class="cancel_button">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" class="submit_button">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <VDialog :isDialogVisible="isOpenDialog" @changeDialogVal="DialogVal" />
  </div>
</template>

<script>
import FirstTitle from "@/views/ReportPlatform/components/ReportFirstTitle.vue";
import VDialog from "@/views/ReportPlatform/components/Dialog.vue";
import { addReport,upload,singleUpload } from "common/js/api";

export default {
  name: "InitiateReport",
  components: {
    FirstTitle,
    VDialog
  },
  data() {
    var IDcardRule = (rule, value, callback) => {
      let p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!value) {
        callback(new Error("身份证号码格式不正确"));
      } else {
        if (p.test(value) == true) {
          callback();
        } else {
          callback(new Error("身份证号码格式不正确"));
        }
      }
    };
    var userphoneRule = (rule, value, callback) => {
      let p = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
      if (!value) {
        callback(new Error("手机号格式不正确"));
      } else {
        if (p.test(value) == true) {
          callback();
        } else {
          callback(new Error("手机号格式不正确"));
        }
      }
    };
    return {
      titleName: "发起举报",
      currentFile: "",
      isOpenDialog: false,
      reportFileOrginName: "",
      reportFileStorePath: "",
      // reportFileStorePath: "",
      ruleForm: {
        agencyName: "",
        reportReason: "",
        reportName: "",
        reportIdNumber: "",
        reportPhone: "",
        file: "",
        reportFileStorePath: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入举报机构名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        username: [
          { required: true, message: "请输入您的姓名", trigger: "blur" }
        ],
        desc: [
          { required: true, message: "请输入事项及理由", trigger: "blur" }
        ],
        IDcard: [
          {
            required: true,
            validator: IDcardRule,
            trigger: "blur"
          }
        ],
        userphone: [
          {
            required: true,
            validator: userphoneRule,
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getFile(event) {
      const file = event.target.files[0];
      this.currentFile = file.name;
      this.ruleForm.file = file;
      this.getFilemessage();
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    
    async submit() {
      const params ={
        agencyName: this.ruleForm.agencyName,
        reportFileOrginName: this.reportFileOrginName,
        reportFileStorePath: this.ruleForm.reportFileStorePath,
        reportIdNumber: this.ruleForm.reportIdNumber,
        reportName: this.ruleForm.reportName,
        reportPhone: this.ruleForm.reportPhone,
        reportReason: this.ruleForm.reportReason,
        userInstitutionCode: this.Cookies.get("identifyCode")
      }
      // const code = this.Cookies.get("identifyCode");
      
      
      await addReport(params);
      this.isOpenDialog = true;
    },
    async getFilemessage() {
      let formData = new FormData();
      for (let key in this.ruleForm) {
        formData.append(key, this.ruleForm[key]);
      }
      const {result} = await upload(formData);
      this.reportFileOrginName = result.orignName;
      this.reportFileStorePath = result.storePath;
      this.ruleForm.reportFileStorePath = result.storePath;
      
    },
    DialogVal(val) {
      this.isOpenDialog = val;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.push('/ReportPlatform/ReportList')
    },
    handleRemove(file, fileList) {
  
    },
    handlePreview(file) {
      
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style scoped>
.report_form {
  padding-top: 20px;
}
.report_form >>> .el-upload-list__item {
  font-size: 14px;
  color: #3165ff;
  background: #f3f3f3;
  border-radius: 2px;
}
.report_form >>> .el-form-item__label {
  text-align: left;
}
.report_form >>> .el-upload__tip {
  display: inline-block;
  margin-top: 0;
  font-size: 14px;
  color: #b6bcc2;
}
.report_form >>> .button_style {
  width: 100px;
  height: 28px;
  font-size: 14px;
  padding: 0 !important;
  margin-right: 10px;
  text-align: center;
  color: #3165ff;
  border: 1px solid #3165ff;
  border-radius: 2px;
  background: transparent;
}
.report_form >>> .el-form-item {
  margin-bottom: 25px !important;
}
.form_button button {
  width: 100px;
}
.form_button .cancel_button {
  border: 1px solid #dddddd;
  border-radius: 2px;
}
.form_button .submit_button {
  background: #3165ff;
  border-radius: 2px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}

/* upload */
.form {
  text-align: center;
}
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  border-radius: 2px;
  box-sizing: border-box;
  /* width: 70%;
  height: 115px; */
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

a {
  text-decoration: none;
  border: 1px solid #3165ff;
  padding: 10px 20px;
  line-height: 10px;
  color: #3165ff;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
.currFile {
  display: inline-block;
  vertical-align: text-bottom;
  padding: 0px 20px;
}
</style>
